module.exports = `
<% if(name.length > 0){ %>
	<h3 class="cap-heading <%= isExpanded ? 'all-expanded' : '' %>"><%= name %></h3>
<% } %>

<div class="cap-set <%= isExpanded ? 'all-expanded' : '' %>">
  <div class="cap-grouping">
	  <%- optionsHTML %>
  </div>
</div>
`